export const environment = {
  production: true,
  apiUrl: 'https://promo-portal-api.herokuapp.com',
  mockApiUrl: 'https://rqbvl5fhof.execute-api.ap-southeast-2.amazonaws.com/promo-portal-mock-api',
  pptlApi: 'https://promo-portal-g-uat-ext.smcdp-aws.net',
  gaKey: 'UA-176056107-2',
};
